/**
 * @generated SignedSource<<ae82ee3847fa9d5e0b2bc5676ea8bef3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateMethodOfUseInput = {
  description: string;
};
export type UpdateProcedureInput = {
  description: string;
};
export type UpdateEaseOfUseRatingInput = {
  description: string;
};
export type UpdateAgeGroupInput = {
  beginAge: number;
  endAge: number;
  groupNumber: number;
  groupPercentage: number;
};
export type UpdateJobCategoryMutation$variables = {
  ageGroups?: ReadonlyArray<UpdateAgeGroupInput | null> | null;
  description?: string | null;
  easeOfUseRatings?: ReadonlyArray<UpdateEaseOfUseRatingInput | null> | null;
  id: string;
  methodsOfUse?: ReadonlyArray<UpdateMethodOfUseInput | null> | null;
  name: string;
  parentId?: string | null;
  procedures?: ReadonlyArray<UpdateProcedureInput | null> | null;
  reportType?: string | null;
};
export type UpdateJobCategoryMutation$data = {
  readonly updateJobCategory: {
    readonly ageGroups: ReadonlyArray<{
      readonly beginAge: number;
      readonly endAge: number;
      readonly groupNumber: number;
      readonly groupPercentage: number;
    }>;
    readonly description: string | null;
    readonly easeOfUseRatings: ReadonlyArray<{
      readonly description: string;
    }>;
    readonly id: string;
    readonly methodsOfUse: ReadonlyArray<{
      readonly description: string;
    }>;
    readonly name: string;
    readonly parentId: string | null;
    readonly procedures: ReadonlyArray<{
      readonly description: string;
    }>;
    readonly reportType: string | null;
  } | null;
};
export type UpdateJobCategoryMutation = {
  response: UpdateJobCategoryMutation$data;
  variables: UpdateJobCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ageGroups"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "easeOfUseRatings"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "methodsOfUse"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "procedures"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportType"
},
v9 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "ageGroups",
        "variableName": "ageGroups"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "easeOfUseRatings",
        "variableName": "easeOfUseRatings"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "methodsOfUse",
        "variableName": "methodsOfUse"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "parentId",
        "variableName": "parentId"
      },
      {
        "kind": "Variable",
        "name": "procedures",
        "variableName": "procedures"
      },
      {
        "kind": "Variable",
        "name": "reportType",
        "variableName": "reportType"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reportType",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v15 = [
  (v12/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beginAge",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAge",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupPercentage",
  "storageKey": null
},
v20 = [
  (v12/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateJobCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "JobCategory",
        "kind": "LinkedField",
        "name": "updateJobCategory",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MethodOfUse",
            "kind": "LinkedField",
            "name": "methodsOfUse",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Procedure",
            "kind": "LinkedField",
            "name": "procedures",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EaseOfUseRating",
            "kind": "LinkedField",
            "name": "easeOfUseRatings",
            "plural": true,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgeGroup",
            "kind": "LinkedField",
            "name": "ageGroups",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateJobCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "JobCategory",
        "kind": "LinkedField",
        "name": "updateJobCategory",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MethodOfUse",
            "kind": "LinkedField",
            "name": "methodsOfUse",
            "plural": true,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Procedure",
            "kind": "LinkedField",
            "name": "procedures",
            "plural": true,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EaseOfUseRating",
            "kind": "LinkedField",
            "name": "easeOfUseRatings",
            "plural": true,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgeGroup",
            "kind": "LinkedField",
            "name": "ageGroups",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66ff033cc7ce11d85446612c750972fa",
    "id": null,
    "metadata": {},
    "name": "UpdateJobCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateJobCategoryMutation(\n  $id: ID!\n  $name: String!\n  $description: String\n  $reportType: String\n  $parentId: ID\n  $methodsOfUse: [UpdateMethodOfUseInput]\n  $procedures: [UpdateProcedureInput]\n  $easeOfUseRatings: [UpdateEaseOfUseRatingInput]\n  $ageGroups: [UpdateAgeGroupInput]\n) {\n  updateJobCategory(input: {id: $id, name: $name, description: $description, reportType: $reportType, parentId: $parentId, methodsOfUse: $methodsOfUse, procedures: $procedures, easeOfUseRatings: $easeOfUseRatings, ageGroups: $ageGroups}) {\n    id\n    name\n    description\n    reportType\n    parentId\n    methodsOfUse {\n      description\n      id\n    }\n    procedures {\n      description\n      id\n    }\n    easeOfUseRatings {\n      description\n      id\n    }\n    ageGroups {\n      groupNumber\n      beginAge\n      endAge\n      groupPercentage\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94557fe32dd933134bd8af782491616d";

export default node;
